import { render, staticRenderFns } from "./dianliu.vue?vue&type=template&id=801dc856&scoped=true&"
import script from "./dianliu.vue?vue&type=script&lang=js&"
export * from "./dianliu.vue?vue&type=script&lang=js&"
import style0 from "./dianliu.vue?vue&type=style&index=0&id=801dc856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801dc856",
  null
  
)

export default component.exports